<template>
  <div class="book-time-single-date-xs">
    <div class="provider-and-calendar-nav-mobile-buttons">
      <ToggleSelectProviderMobile />
    </div>
    <div class="provider-and-calendar-nav-mobile-buttons">
      <ToggleSelectLocationMobile />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import ToggleSelectProviderMobile from "./ToggleSelectProviderMobile.vue";
import ToggleSelectLocationMobile from "./ToggleSelectLocationMobile.vue";
export default {
  components: { ToggleSelectProviderMobile, ToggleSelectLocationMobile },
  computed: {
    ...mapState(["ui", "providers", "locations"]),
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["calendarViewType", "toggleSelectingProvider"]),
  },
};
</script>
